import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-participantessorteopt',
  templateUrl: './participantessorteopt.component.html',
  styleUrls: ['./participantessorteopt.component.scss']
})
export class ParticipantessorteoptComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
